module.exports = __webpack_public_path__ + "static/media/070-man-15.32980e10.svg";